<template>
  <div>
    <Disclosure
      v-slot="{ open }"
      :default-open="isExpanded"
    >
      <DisclosureButton
        class="flex w-full items-center justify-between"
        :class="titleClass"
        @click.stop
      >
        <div v-if="slots.title">
          <slot name="title"></slot>
        </div>

        <div
          v-if="slots.icon"
          :class="open ? '-mb-3 mr-1 rotate-90 transform' : ''"
        >
          <slot name="icon"></slot>
        </div>
        <img
          v-else
          class="mr-2.5"
          :class="open ? 'rotate-90 transform' : ''"
          src="@/assets/collapsible-arrow.svg"
          alt="arrow icon"
        />
      </DisclosureButton>

      <transition
        :enter-active-class="`transition duration-0 ease-out`"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        :leave-active-class="`transition duration-0 ease-out`"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <DisclosurePanel>
          <div v-if="slots.content">
            <slot name="content"></slot>
          </div>
        </DisclosurePanel>
      </transition>
    </Disclosure>
  </div>
</template>

<script setup>
import { useSlots } from 'vue';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';

const slots = useSlots();

defineProps({
  duration: {
    type: String,
    required: false,
    default: '0',
  },
  titleClass: {
    type: String,
    required: false,
  },
  isExpanded: {
    type: Boolean,
    default: true,
  },
});
</script>
